import styled from 'styled-components';
import { Checkbox as CuiCheckbox } from '@chegg-ui/checkbox';
import { colors, font, themes } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
export var TermsAndPromosDiv = styled.div.withConfig({
  componentId: "sc-yhsr4a-0"
})(["display:flex;flex-direction:column;gap:", ";font-size:", ";"], themes.horizon.spacing.md, font.size.px16);
export var Checkbox = styled(CuiCheckbox).withConfig({
  componentId: "sc-yhsr4a-1"
})(["line-height:", ";letter-spacing:", ";"], themes.horizon.font.lineHeight.sm, themes.horizon.font.letterSpacing.lg);
export var InfoLink = styled(Link).withConfig({
  componentId: "sc-yhsr4a-2"
})(["cursor:pointer;font-weight:", ";:hover{color:", ";}"], themes.horizon.font.weight.bold, colors.violet700);